import script from "./SignupMatchSubject.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupMatchSubject.vue?vue&type=script&setup=true&lang=js"

import "./SignupMatchSubject.vue?vue&type=style&index=0&id=7b418756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b418756"]])

export default __exports__